// @flow

import React from 'react';

import { BaseModal } from './BaseModal';
import { ModalOKButton } from './ModalOKButton';

export const AlertModal = ({
  body,
  header,
  isOpen,
  onClose,
  okButtonText = 'OK',
  fullScreen = false,
}) => (
  <BaseModal
    actions={<ModalOKButton content={okButtonText} onClick={onClose} />}
    body={body}
    closeWhenClickedOutside={true}
    fullScreen={fullScreen}
    header={header}
    isOpen={isOpen}
    onClose={onClose}
  />
);
